import type { RecurrenceException } from "./DateRecurrencePicker.types";

interface RecurrenceLinesOptions {
  value?: string | null;
  startDate?: string | null;
  exceptions?: RecurrenceException[];
}

export function recurrenceLines({
  value,
  startDate,
  exceptions = [],
}: RecurrenceLinesOptions): string[] {
  const skipped = exceptionLine(exceptions);

  return [
    startDate ? `DTSTART;VALUE=DATE:${compact(startDate)}` : null,
    `RRULE:${value ?? ""}`,
    skipped,
  ].filter((line): line is string => null !== line);
}

function exceptionLine(exceptions: RecurrenceException[]): string | null {
  const parts = exceptions
    .map((exception) => {
      switch (exception.type) {
        case "holidays":
          return "SCHOOL-HOLIDAYS";
        case "weeks":
          return `WEEKS=${exception.nbWeeks ?? 0}`;
        default:
          return exception.start && exception.stop
            ? `${"yearlydates" === exception.type ? "YEARLY-DATES" : "DATES"}=${compact(exception.start)}/${compact(exception.stop)}`
            : null;
      }
    })
    .filter((part): part is string => null !== part);

  return parts.length > 0 ? `X-EXCEPTIONS:${parts.join(";")}` : null;
}

function compact(date: string): string {
  return date.replace(/-/g, "");
}
